import * as React from 'react';
export const IcMoneyLoan = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.49 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM19.71 14.89a.978.978 0 00-1.41 0l-2.53 2.53c-.38.38-.88.59-1.41.59h-3.35c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1h-4c-1.1 0-2 .9-2 2h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h9.35c1.07 0 2.07-.42 2.83-1.17l2.53-2.53a.996.996 0 000-1.41l-.01-.01z'
      fill='currentColor'
    />
  </svg>
);
